<template>
  <div
    type="button"
    @click="handleClick(name)"
    class="absolute right-4 top-1/2 transform -translate-y-1/2 cursor-pointer"
  >
    <img :src="showPasswordIcon" width="20" height="22" loading="lazy" alt="" />
  </div>
</template>

<script>
import showPassword from "@/mixins/showPassword";

export default {
  name: "CoreErrorMessage",
  props: ["name"],
  data() {
    return {
      isVisible: false,
    };
  },
  mixins: [showPassword],
  computed: {
    showPasswordIcon() {
      const status = this.isVisible;
      let icon;
      if (!status) {
        icon = "eye";
      } else {
        icon = "eye-close";
      }
      return require(`@/assets/images/base/icons/${icon}.svg`);
    },
  },
  methods: {
    handleClick(name) {
      this.showPassword(name);
      this.isVisible = !this.isVisible;
    },
  },
};
</script>

<style lang="scss" scoped></style>
